var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteigenberg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    viewBox: "0 0 63 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3:140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5616 0H38.4589V0.00434225H49.5616V0Z",
    fill: "#0455BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3798 22.0022L49.5616 44H38.4589L51.277 22.0022L44.0124 9.53129L49.5616 0.00439453L62.3798 22.0022Z",
    fill: "#0455BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5616 0.00439453L44.0124 9.53129L23.9209 44L18.3717 34.4775L38.4589 0.00439453H49.5616Z",
    fill: "#0CB1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3717 34.4775L23.9209 44H12.8182L0 22.0022L12.8182 0H23.9209L11.1027 22.0022L18.3717 34.4775Z",
    fill: "#0455BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3:140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.3797,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteigenberg);
export default __webpack_public_path__ + "static/media/Steigenberg.4773e652a303bdd651ea0d9e05f66a75.svg";
export { ForwardRef as ReactComponent };